(() => {
  const init = () => {
    const root = document.querySelector('#sh-v2');
    if (!root || root.dataset.usecaseReady) return;
    const panel = root.querySelector('[data-sh-mask-usecase]');
    const configNode = root.querySelector('[data-sh-usecase-config]');
    const title = root.querySelector('.sh-title');
    const subtitle = root.querySelector('.sh-hook');
    if (!panel || !configNode || !title || !subtitle) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch { return; }
    const original = {title: title.textContent, subtitle: subtitle.innerHTML};
    const apply = () => {
      const values = new URL(window.location.href).searchParams.getAll('usecase');
      const key = values.length === 1 ? values[0] : '';
      if (!Object.prototype.hasOwnProperty.call(config, key)) {
        if (root.dataset.usecaseActive) {
          title.textContent = original.title;
          subtitle.innerHTML = original.subtitle;
        }
        panel.hidden = true;
        delete root.dataset.usecaseActive;
        return;
      }
      const selected = config[key];
      title.textContent = selected.title;
      subtitle.textContent = selected.subtitle;
      panel.querySelector('[data-usecase-badge]').textContent = selected.badge;
      const image = panel.querySelector('.sh-usecase-image');
      const url = new URL(selected.image, window.location.origin);
      if (url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.hostname === window.location.hostname)) {
        image.removeAttribute('srcset');
        image.src = url.href;
        image.alt = selected.alt;
      }
      root.dataset.usecaseActive = key;
      panel.hidden = false;
    };
    root.dataset.usecaseReady = 'true';
    apply();
    window.addEventListener('popstate', apply);
    panel.querySelector('.sh-usecase-cta').addEventListener('click', event => {
      const target = root.querySelector('#sh-mask-offer-choice');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center'});
      target.focus({preventScroll: true});
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
